import { get, post, patch, remove } from "./base";
import store from "../store";
import * as actions from "../store/actions/userProfile";
import { loginEndFailed, userMessage } from "../store/actions/auth";

import objectToParams from "./params";
import url from "./url";
import queries from "./queries";

const { dispatch } = store;

export default class userAPI {
  static async getUserInfo({ id = "0", headers = {} } = {}) {
    try {
      dispatch(actions.getUserInfo());
      const query = url(queries.userProfile, id);
      const response = await get(query, headers);
      return dispatch(actions.getUserInfoSuccess(response));
    } catch (error) {
      const err = (error.response && error.response.data) || error;
      return dispatch(actions.getUserInfoFailed(err));
    }
  }

  static async activate({ data = {}, headers = {} } = {}) {
    try {
      const query = url(queries.userActivate);
      const response = await post(query, data, headers);
      return dispatch(userMessage(response.message));
    } catch (error) {
      if (error.response) {
        const { data: errorData } = error.response;
        const nonFieldErrors = errorData.detail || errorData;
        return dispatch(loginEndFailed({ nonFieldErrors }));
      }
      return dispatch(loginEndFailed(error));
    }
  }

  static async register({ data = {}, headers = {} }) {
    const query = url(queries.userRegister);
    const response = await post(query, data, headers);
    return response;
  }

  static async validateUserData({ data = {}, headers = {} } = {}) {
    const query = url(queries.userValidate);
    const response = await post(query, data, headers);
    return response;
  }

  static async selectSubscription({ data = {}, headers = {} } = {}) {
    const query = url(queries.subscriptionSelect);
    const response = await post(query, data, headers);
    return response;
  }

  static async addBiling({ data = {}, headers = {} } = {}) {
    const query = url(queries.createUserBilling);
    const response = await post(query, data, headers);
    return response;
  }

  static async createStripeCustomer({ data = {}, headers = {} } = {}) {
    const query = url(queries.stripeCustomer);
    const response = await post(query, data, headers);
    return response;
  }

  static async createStripeSubscription({ data = {}, headers = {} } = {}) {
    const query = url(queries.stripeSubscription);
    const response = await post(query, data, headers);
    return response;
  }

  static async resetPassword({ data = {}, headers = {} } = {}) {
    try {
      dispatch(actions.resetPassword());
      const query = url(`${queries.userResetPassword}reset`);
      await post(query, data, headers);
      return dispatch(
        userMessage(
          "If email address present on our system, we will send a password restoration link to this email address."
        )
      );
    } catch (error) {
      return dispatch(
        userMessage(
          "If email address present on our system, we will send a password restoration link to this email address."
        )
      );
    }
  }

  static async restorePassword({ data = {}, headers = {} }) {
    const query = url(queries.userRestorePassword);
    await post(query, data, headers);
    return dispatch(userMessage("Your password has been changed!"));
  }

  static async deactivatedUser({ id = "", headers = {} }) {
    const query = url(queries.deactivated, id);
    const response = await get(query, headers);
    return response;
  }

  static async invite({ data = {}, headers = {} }) {
    const query = url(queries.invite);
    const response = await post(query, data, headers);
    return response;
  }

  static async invitedUser({ data = {}, params = {}, headers = {} }) {
    const stringParams = objectToParams(params);
    const query = url(queries.inviteInfo);
    const response = await post(query + stringParams, data, headers);
    return response;
  }

  static async inviteActivate({ data = {}, headers = {} }) {
    const query = url(queries.inviteActivate);
    const response = await post(query, data, headers);
    return response;
  }

  static async getProfiles({ headers = {} } = {}) {
    try {
      dispatch(actions.profilesGet());
      const query = url(queries.userProfile);
      const response = await get(query, headers);
      return dispatch(actions.profilesGetSuccess(response));
    } catch (error) {
      const err = (error.response && error.response.data) || error;
      return dispatch(actions.profilesGetFailed(err));
    }
  }

  static async updateProfile({ id = "", data = {}, headers = {} } = {}) {
    try {
      dispatch(actions.profileEdit());
      const query = url(queries.userProfileUpdate, id);
      const response = await patch(query, data, headers);
      return dispatch(actions.profileEditSuccess(response));
    } catch (error) {
      const err = (error.response && error.response.data) || error;
      return dispatch(actions.profileEditFailed(err));
    }
  }

  static async updateCompany({ id = "", data = {}, headers = {} } = {}) {
    try {
      dispatch(actions.profileEdit());
      const query = url(queries.companyProfileUpdate, id);
      const response = await patch(query, data, headers);
      return dispatch(actions.profileEditSuccess(response));
    } catch (error) {
      const err = (error.response && error.response.data) || error;
      return dispatch(actions.profileEditFailed(err));
    }
  }

  static async updateProfileRole({
    profileId = "",
    role = "",
    headers = {}
  } = {}) {
    try {
      dispatch(actions.profileEdit());
      const query = url(queries.userChangeRole);
      const response = await patch(query, { profileId, role }, headers);
      return dispatch(actions.profileEditSuccess(response));
    } catch (error) {
      const err = (error.response && error.response.data) || error;
      return dispatch(actions.profileEditFailed(err));
    }
  }

  static async removeProfile({ data = {}, headers = {} } = {}) {
    try {
      dispatch(actions.profilesGet());
      const query = url(queries.userProfile, data.id);
      const response = await remove(query, headers);
      return dispatch(actions.profilesGetSuccess(response));
    } catch (error) {
      const err = (error.response && error.response.data) || error;
      return dispatch(actions.profilesGetFailed(err));
    }
  }

  static async updateAvatar({ data = {}, headers = {} } = {}) {
    try {
      // dispatch(actions.profilesGet());
      const query = url(queries.userAvatar);
      await post(query, data, headers);
      // return dispatch(actions.profilesGetSuccess());
    } catch (error) {
      const err = (error.response && error.response.data) || error;
      console.error(err);
      // return dispatch(actions.profilesGetFailed(err));
    }
  }

  static async updateCompanyLogo({ data = {}, headers = {} } = {}) {
    try {
      // dispatch(actions.profilesGet());
      const query = url(queries.companyAvatar);
      await post(query, data, headers);
      // return dispatch(actions.profilesGetSuccess());
    } catch (error) {
      const err = (error.response && error.response.data) || error;
      console.error(err);
      // return dispatch(actions.profilesGetFailed(err));
    }
  }
}
